import React from 'react';
import { Grid, Step, Stepper, useMediaQuery, useTheme } from '@mui/material';
import { OrderStepConnector, OrderStepIcon, OrderStepLabel } from './CustomStepper';
import { OrderPageTypography } from '../themedComponents/OrderPageTypography';
import { useIntentConfig } from '../intentConfig/useIntentConfig';

const OrderPageStepper = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { visibleSteps, currentStepIndex } = useIntentConfig();

  return (
    <Grid container hidden={isSmallScreen} display={isSmallScreen ? 'none' : 'flex'} flexDirection="column">
      <Stepper activeStep={currentStepIndex} alternativeLabel connector={<OrderStepConnector />}>
        {visibleSteps.map((step) => (
          <Step key={step.id}>
            <OrderStepLabel StepIconComponent={OrderStepIcon}>
              <Grid mt={-1.4}>
                <OrderPageTypography>{step.stepperLabel}</OrderPageTypography>
              </Grid>
            </OrderStepLabel>
          </Step>
        ))}
      </Stepper>
    </Grid>
  );
};

export default OrderPageStepper;
